import type {
  AuthPractice,
  Practice,
} from "@elation/api-client/src/stitch-web/models";

import { formatPostalAddress } from "@src/shared/utils/address";

import type { PracticeInfoFormValues } from "./practice.schemas";

type MaybePractice = AuthPractice | Practice | null | undefined;

export const PracticeEntity = {
  id(practice: MaybePractice): number | null {
    return practice?.id ?? null;
  },

  displayName(practice: MaybePractice): string | null {
    return practice?.name?.trim() || null;
  },

  address(practice: MaybePractice): string | null {
    if (!practice) return null;
    return formatPostalAddress(practice);
  },

  timezone(practice: MaybePractice): string | null {
    return practice?.timezone?.trim() || null;
  },

  isActive(practice: MaybePractice): boolean {
    return Boolean(
      practice && "status" in practice && practice.status === "active",
    );
  },

  toInfoFormValues(practice: MaybePractice): PracticeInfoFormValues {
    return {
      name: practice?.name ?? "",
      addressLine1: practice?.addressLine1 ?? "",
      addressLine2: practice?.addressLine2 ?? "",
      city: practice?.city ?? "",
      state: practice?.state ?? "",
      zip: practice?.zip ?? "",
    };
  },
} as const;
